import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkLoggedIn } from '../Redux/AuthReducer/action';
import { useGetPlanSections } from '../Routes/customHooks';


const sections  = [
  { Public: "public" },
  { Web: "web" },
  { "Classical Homeopathy": "classical_homeopathy" },
  { "Treatment Package": "treatmentPackage" },
  { "Alternative Therapies": "alternative_therapies" },
  { "Health Packages": "health_packages" },
  { Testimonials: "testimonials" },
  { "Online Clinic": "online_clinic" },
  { "Contact Us": "contact_us" },
  { "Privacy Policy": "privacy_policy" },
  { Feedback: "feedback" },
  { Popup: "popup" },
  { Agreement: "aggrement" },
  { Payment: "payment" },
  { Dashboard: "dashboard" },
  { Enquiry: "enquiry" },
  { Appointment: "appointment" },
  { Prescription: "prescription" },
  { Doctors: "doctors" },
  { "Assistant Doctor": "assistantDoctor" },
  { Patients: "patients" },
  { "Alternative Therapies Page": "AlternativeTherapies" },
  { Bids: "Bids" },
  { Receptionist: "receptionist" },
  { Transaction: "transaction" },
  { Consultant: "consultant" },
  { Graphs: "graphs" },
  { "Income Expenses": "income_expenses" },
  { Main: "main" },
  { "Clinic Profile": "clinic-profile" },
];

let allowedLinks = sections?.map(s=>Object.values(s)?.[0])

export default function PrivateRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const userLoginRole = useSelector((state) => state.AuthReducer.userLoginRole);
  const storedUserData = sessionStorage.getItem('clinic-application-jwt');
  let sections = useGetPlanSections()

  sections = userLoginRole === 'Admin'?['plans']:[...(sections||[]), 'dashboard', 'clinic-profile', 'site-config']

  if (storedUserData) {
    const { data } = JSON.parse(storedUserData);
    
    dispatch({
      type: 'USER_LOGIN_SUCCESS',
      payload: {
        data,
        message: '', 
      },
    });
    if (sections?.includes(currentPath?.split("/")?.[1])) {
      return children;
    }
  } else {
    if (!window.location.pathname.startsWith('/public')) {
      return <Navigate to="/login" />;
    }

    if (sections?.includes(currentPath?.split("/")?.[1])) {
      return children;
    }
  }
}
